import { render, staticRenderFns } from "./TodoLeftSidebarConfig.vue?vue&type=template&id=437ca192&scoped=true&"
import script from "./TodoLeftSidebarConfig.vue?vue&type=script&lang=js&"
export * from "./TodoLeftSidebarConfig.vue?vue&type=script&lang=js&"
import style0 from "./TodoLeftSidebarConfig.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TodoLeftSidebarConfig.vue?vue&type=style&index=1&id=437ca192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437ca192",
  null
  
)

export default component.exports